var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.groupCols,"simple":""},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}})}
var staticRenderFns = []

export { render, staticRenderFns }